import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { Tabs } from "@performyard/py-components";

// Components
import { Grid, GridCol } from "../../components/Grid";
import CompanyLinks from "./CompanyLinks";

import Documents from "../Documents";
import css from "./CompanyResources.module.scss";

const CompanyResources = () => {
	const location = useLocation();
	const isResourcesPage = location.pathname.includes("company/resources");

	const [activeTab, setActiveTab] = useState<"documents" | "links">("documents");

	useEffect(() => {
		setActiveTab(isResourcesPage ? "documents" : "links");
	}, [isResourcesPage]);

	const handleTabChange = (value: string) => {
		if (value === "documents" || value === "links") {
			setActiveTab(value);
		}
	};

	return (
		<>
			<Grid className={css.Grid} cols={12} gap={4} padding={7}>
				<GridCol span={12}>
					<Tabs
						tabs={[
							{
								value: "documents",
								label: "Documents",
								content: <></>,
							},
							{
								value: "links",
								label: "Company Links",
								content: <></>,
							},
						]}
						value={activeTab}
						onValueChange={handleTabChange}
						urlParam="tab"
						color="neutral"
						size="large"
						dangerouslySetClassName="!gap-0"
					/>
				</GridCol>
			</Grid>
			{activeTab === "documents" ? <Documents showEmployeeCard={false} /> : <CompanyLinks />}
		</>
	);
};

export default CompanyResources;
